import { useOrganisationCustomFields } from "@RequestFormV2/sections/Organisation/hooks/useOrganisationCustomFields";
import OrganisationDynamicField from "@RequestFormV2/sections/Organisation/components/ShipmentDetailsSection/OrganisationDynamicField";

export default function OrganisationCustomFields() {
  const { visibleFields, getDropdownOptions, handleConditionalSelect, isFieldDisabled, setValue } =
    useOrganisationCustomFields();

  return (
    <div className="rfv2-two-column-grid mt-3xl">
      {visibleFields.map((field) => {
        const { field_id, dropdown_values } = field;
        const hasConditionalUpdate = (dropdown_values as any[])?.some((item) => item.updates?.length > 0) ?? false;

        return (
          <OrganisationDynamicField
            key={field.field_id}
            field={field}
            getDropdownOptions={getDropdownOptions}
            isDisabled={isFieldDisabled(field_id)}
            unknownTypeBehavior="readonly"
            onDropdownChange={(value) => {
              if (field_id === "reason_code_group") setValue("organizational.reason_code", null);
              if (hasConditionalUpdate) handleConditionalSelect(value, field);
            }}
          />
        );
      })}
    </div>
  );
}
